<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="$store.getters.role_name == 'admin' || $store.getters.role_name == 'super admin'  || $store.getters.role_name == 'manager' ">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <!-- <div class="page-name">List Tickets</div> -->
                    <div class="page-name">All Tickets</div>
                    <button type="button" class="btn btn-secondary" v-on:click="exportTicket($event)">Export</button>
                </div>
                        
                <!--page content-->
                <div class="admin-page-content">
                    <div class="card">
                        <h5 class="card-header" style="background:#f5f5f5;">
                            <div class="selectdate">
                                <div class="selectbox1">
                                    <v-select v-model="selectedLocation" name="location"
                                            placeholder="Type location here"
                                            label="location_name"
                                            :options="locationOptions" class=""
                                            v-on:change="loadTickets" >
                                    </v-select>
                                    <span class="text-danger">{{locationError}}</span>
                                </div>

                                <div class="selectbtn">
                                    <button type="button" class="btn btn-warning applybtn" v-on:click="loadTickets()">Apply Filter</button>
                                    <button type="button" class="btn btn-primary clearbtn" v-on:click="clearFilter()">Clear Filter</button>
                                </div>
                            </div>

                        </h5>
                    </div>

                    <!-- List Content Here -->
                    <div class="app-filter-good-table-container">
                        <vue-good-table
                            ref="ticketList"
                            mode="remote"
                            @on-page-change="onPageChange"
                            @on-selected-rows-change="selectionChanged"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            :totalRows="totalRecords"
                            :columns="columns"
                            :rows="rows"
                            :pagination-options="{
                                enabled: true,
                                mode: 'pages',
                                pageLabel: 'Page',
                                position: 'bottom',
                                perPage: serverParams.perPage,
                                perPageDropdown: [25, 50, 100, 200 ,500],
                                dropdownAllowAll: false,
                                setCurrentPage: serverParams.setCurrentPage,
                            }"
                            :selectOptions="{
                                enabled: false,
                                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                selectionInfoClass: 'custom-class',
                                selectionText: 'rows selected',
                                clearSelectionText: 'clear',
                            }"
                            :search-options="{
                                enabled: false,
                            }">
                            <!-- Custome Pagination -->
                            <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                v-model="serverParams.perPage"
                                                @change="changedValueTask"
                                                @input="changedValueTaskCustomPerPageTask()"
                                                name="customPerPage"
                                                id="customPerPage"
                                                label="text"
                                                :clearable="false"
                                                :searchable="false"
                                                :filterable="false"
                                                :options="serverParams.perPageDropdown"
                                                placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="FirstPage" title="First Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <template v-if="pageNumberListTask() < displayPageTask">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                        <template v-for="(n, index) in displayPageTask">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                        <template v-for="(n, index) in pageNumberListTask()">
                                                            <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="LastPage" title="Last Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <!-- End Custome Pagination -->

                            <!--<div slot="selected-row-actions" slot-scope="computed">-->
                                <!--{{computed.selectedRows}}-->
                                        <!--<button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="deleteTickets()">Delete Tickets({{selectedRows}})</button>-->
                            <!--</div>-->

                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <!--class="btn btn-xs btn-primary"-->
                                    <div v-if="props.column.field == 'action'" class="table-action">
                                        <!--<router-link title='Edit Benefit' class="btn btn-primary" v-bind:to="{name: 'UpdateBenifit',params:{id:props.row.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>-->
                                        <!--<button title='Delete Benefit' id="delete" class="btn btn-primary"  v-on:click.prevent="deleteTickets(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>-->
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
                <!--page content-->   
            </div>
        </template>
        <template v-else>
            <no-permission></no-permission>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {HTTP} from '../http-common';
    import FrontFooter from '@/components/FrontFooter';
    import NoAccessPermission from '@/components/NoAccessPermission'
    import {commonMixins} from '../mixins/commonMixins';
    import vSelect from 'vue-select';

    Vue.use(VueGoodTable);

    var self;
    export default {
        name: 'ListTicket',
        mixins: [commonMixins],
        components: {
            'app-footer':FrontFooter,
            'no-permission': NoAccessPermission,
            vSelect,
        },
        data() {
            return {
                firstLoad: 0,
                columns: [
                    {
                        label: 'Number',
                        field: 'ticket_no',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Number", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        },
                        thClass:'vgt-center-align',
                    },
                    {
                        label: 'Number Generated At',
                        field: 'ticket_generated_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Number Generated At", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Number Closed At',
                        field: 'ticket_closed_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Number Closed At", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Waiting Time',
                        field: 'waiting_time',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Waiting Time", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Handled By',
                        field: 'handled_by',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Handled By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    // {
                    //     label: 'Actions',
                    //     field: 'action',
                    //     html: true,
                    //     sortable: false,
                    //     thClass: 'disable-sorting',
                    // },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                    perPageDropdown : [25, 50, 100, 200, 500],
                    setCurrentPage: 1,
                },
                recordsCounts: "",
                selectedRows: 0,
                displayPageTask: 7,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                jumpToPageTask: 0,
                selectedLocation: null,
                locationError : '',
            }

        },
        beforeMount: function () {
            self = this;
            //self.checkLogin();
        },
        mounted: function () {
            self = this;
            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });
            self.loadLocations(self.onLocationCallback);
        },
        methods: {
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadTickets();
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadTickets();
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadTickets();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadTickets();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('ticket_no');
                    field: ('ticket_generated_at');
                    field: ('ticket_closed_at');
                    field: ('waiting_time');
                    field: ('handled_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.ticket_no || filters.ticket_generated_at || filters.ticket_closed_at || filters.waiting_time || filters.handled_by) {
                    self.loadTickets();
                }

            },
            selectionChanged() {
                var self = this;
                self.selectedRows = (self.$refs['ticketList'].selectedRows).length;
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadTickets();
            },
            clearFilter(){
                let self = this;
                self.selectedLocation = null;
                self.loadTickets();
            },
            onLocationCallback : function() {
                var userObj = JSON.parse(localStorage.getItem("user_obj"));
                
                if (userObj != null) {

                    for(var i = 0; i < self.locationOptions.length; i++) {
                        var locationObject = self.locationOptions[i];
                        if(locationObject.location_id == userObj.location_id) {
                            self.selectedLocation = locationObject;
                            break;
                        }
                    }
                }
                self.loadTickets();
            },
            exportTicket : function (e) {

                var location_id = null;

                if(self.selectedLocation != null) {
                    location_id = self.selectedLocation.location_id; 
                }

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: { 
                        'location_id': location_id,
                        'filters': self.serverParams.columnFilters,
                        'page': self.serverParams.page,
                        'perPage': self.serverParams.perPage,
                    }
                };

                HTTP.get('ticket/export', config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            location.href = response.data.content.web;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },

            loadTickets: function () {
                self.firstLoad = 1;
                self.serverParams.setCurrentPage = self.serverParams.page;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };

                var location_id = null;
                if(self.selectedLocation != null) {
                    location_id = self.selectedLocation.location_id;
                } else {
                    self.locationError = "Please Select Location";
                }

                var data = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    location_id: location_id,
                }

                HTTP.post('ticket/list',data, config)
                    .then(function (response) {

                        if (response.data.code == 200) {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                        }
                        self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },

        }
    }
</script>
<style>
    body {
        margin: 0;
        padding: 0;
        font-family: 'SanFranciscoDisplayRegular' !important;
        background: #f5f5f5 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/ListTicket.vue